import { isCoreHost } from '../services/brandingService'
import { hasNative } from '../services/nativeBridge'
import { isIOS } from './useIosInstallGuide'

// Приложение портала в магазинах. Ссылки без страны и языка: иначе человек попадает
// на чужую витрину (/us/) и магазин просит сменить страну.
export const APP_STORE = { name: 'App Store', url: 'https://apps.apple.com/app/id6814394967' }
export const GOOGLE_PLAY = { name: 'Google Play', url: 'https://play.google.com/store/apps/details?id=com.cloudgps.client' }

// Магазин этого телефона. На компьютере null: ставить там нечего.
const deviceStore = () => {
  if (isIOS()) return APP_STORE
  if (typeof window !== 'undefined' && /android/i.test(window.navigator.userAgent)) return GOOGLE_PLAY
  return null
}

// Предлагаем только на своих хостах: у партнёра домен и бренд дилера, там остаётся PWA.
// Проверяем список хостов, а не isWhiteLabel(): бренд партнёра приходит запросом,
// и при первом визите магазин успел бы мелькнуть на его домене.
const canOfferStore = () => isCoreHost() && !hasNative()

// Для баннера и подсказок: только свой магазин телефона
export const offeredStore = () => (canOfferStore() ? deviceStore() : null)

// Для справки: на телефоне его магазин, на компьютере оба
export const offeredStores = () => {
  if (!canOfferStore()) return []
  const store = deviceStore()
  return store ? [store] : [APP_STORE, GOOGLE_PLAY]
}
